import { Phone, Mail, MapPin, Smartphone, Wallet, DollarSign } from "lucide-react";
import { CONTACT, PAYMENTS, IMAGES } from "@/lib/data";

const PAY_ICONS = {
  "Cash App": DollarSign,
  Venmo: Smartphone,
  "Apple Pay": Wallet,
};

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-secondary text-navy border-t-2 border-gold/40">
      {/* Payments strip */}
      <div id="payments" className="border-b border-navy/10 py-10 bg-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="flex flex-col md:flex-row md:items-center gap-6 justify-between">
            <span className="text-gold-dark text-xs font-bold uppercase tracking-[0.25em]">We Accept</span>
            <div className="flex flex-wrap gap-3">
              {PAYMENTS.map((p) => {
                const Icon = PAY_ICONS[p] || DollarSign;
                return (
                  <div
                    key={p}
                    data-testid={`payment-${p.toLowerCase().replace(/ /g, "-")}`}
                    className="flex items-center gap-2 rounded-full bg-secondary border border-navy/10 px-5 py-2.5"
                  >
                    <Icon className="w-4 h-4 text-gold-dark" />
                    <span className="font-semibold text-sm text-navy">{p}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <img src={IMAGES.logo} alt="ORL On Demand Rides logo" className="h-12 w-auto" />
            <p className="mt-5 text-muted-foreground max-w-md leading-relaxed">
              Affordable car rentals for rideshare drivers, delivery drivers and travel nurses.
              Drive more. Worry less. We handle the rest.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 text-muted-foreground text-sm">
              <MapPin className="w-4 h-4 text-gold-dark" /> {CONTACT.location}
            </div>
          </div>

          <div className="md:text-right">
            <p className="text-gold-dark text-xs font-bold uppercase tracking-[0.25em] mb-4">Get In Touch</p>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              data-testid="footer-call-link"
              className="flex md:justify-end items-center gap-2 text-2xl md:text-3xl font-heading font-bold text-navy hover:text-gold-dark transition-colors"
            >
              <Phone className="w-6 h-6 text-gold-dark" /> {CONTACT.phoneDisplay}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="footer-email-link"
              className="mt-3 flex md:justify-end items-center gap-2 text-muted-foreground hover:text-gold-dark transition-colors break-all"
            >
              <Mail className="w-4 h-4 text-gold-dark" /> {CONTACT.email}
            </a>
            <a
              href={`sms:${CONTACT.phoneRaw}`}
              data-testid="footer-text-btn"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 text-white font-bold hover:bg-navy-light transition-colors"
            >
              <Smartphone className="w-4 h-4" /> Text Us Now
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-navy/10 flex flex-col sm:flex-row justify-between gap-3 text-muted-foreground text-sm">
          <span>© {new Date().getFullYear()} {CONTACT.brand} {CONTACT.brandSub}. All rights reserved.</span>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-navy transition-colors">Owner Login</a>
        </div>
      </div>
    </footer>
  );
};
